module.exports = __webpack_public_path__ + "static/img/1089.b5f8ece.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1089.jpg
// module id = 271
// module chunks = 0